import { useQuery } from "@tanstack/react-query";
import { reactQueryCacheAndRefetchOptions } from "@";
import { statisticsKeys } from "./keys.ts";
import { getVerificationStatistics } from "../api.ts";
import type { VerificationStatistics } from "../../types.ts";

export const useVerificationStatisticsQuery = (
  fromDate?: string,
  toDate?: string,
) => {
  return useQuery<VerificationStatistics>({
    queryKey: statisticsKeys.numbers(fromDate, toDate),
    queryFn: async () => {
      const { data } = await getVerificationStatistics(fromDate, toDate);
      return data;
    },
    ...reactQueryCacheAndRefetchOptions,
  });
};
